export function getTime(rawTime: string): number {
  if (!rawTime) return 30;

  try {
    const time = rawTime.toLowerCase().replace(/\s+/g, ' ').trim();

    // Extract all numbers (e.g., from "20-35 mins", "1 hr 30 min", etc.)
    const matches = time.match(/\d+/g)?.map(Number);
    if (!matches || matches.length === 0) return 30;

    // Try to determine the minimum time (for ranges or fuzzy formats)
    let min = Math.max(...matches);

    // Handle hours-to-minutes conversion if "hour", "hr", "h" is present
    const isHour = /h(our)?s?/.test(time);
    const isMinute = /min(ute)?s?/.test(time);

    // Heuristic: if both hours and minutes are present like "1h 30m"
    let totalMinutes = 0;

    if (time.includes('h') && time.includes('m')) {
      const hMatch = time.match(/(\d+)\s*h/);
      const mMatch = time.match(/(\d+)\s*m/);

      const h = hMatch ? parseInt(hMatch[1]) : 0;
      const m = mMatch ? parseInt(mMatch[1]) : 0;

      totalMinutes = h * 60 + m;
    } else if (isHour && !isMinute) {
      totalMinutes = min * 60;
    } else {
      totalMinutes = min;
    }

    // Handle fuzzy terms like "over", "about", "less than"
    if (/over|more than/.test(time)) {
      totalMinutes += 5; // bump up
    } else if (/less than/.test(time)) {
      totalMinutes -= 5; // bump down
    }

    // Clamp time to be non-negative
    totalMinutes = Math.max(0, totalMinutes);
    return totalMinutes;
  } catch (err) {
    console.log(err);
    return 30;
  }
}

export default function classifyCookTime(rawTime: string): string {
  try {
    const totalMinutes = getTime(rawTime);
    // Final classification
    if (totalMinutes <= 15) return "Quick";
    if (totalMinutes <= 30 && totalMinutes > 15) return "Medium";
    return "Leisurely";
  } catch (error) {
    // Logger.error(`Error classifying cook time: ${error}`);
    return "Unknown";
  }
}

export function classifyCalories(calories: number): string {
  if (calories < 500) return "Light";
  if (calories >= 400 && calories <= 700) return "Balanced";
  if (calories >= 701) return "Hearty";
  return "Light"
}

